var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    transform: "translate(0 0)",
    fill: "#00e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.864,2.211,12.713.916a.755.755,0,0,1,.629.068.59.59,0,0,1,.294.5V5.792a.59.59,0,0,1-.293.5.754.754,0,0,1-.627.069L8.864,5.076v.985A1.3,1.3,0,0,1,7.5,7.273H1.364A1.3,1.3,0,0,1,0,6.061V1.212A1.3,1.3,0,0,1,1.364,0H7.5A1.3,1.3,0,0,1,8.864,1.212v1Z",
    transform: "translate(3.182 6.364)",
    fill: "##f4aaa4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c17c7ae98ac4b22f9f22e632d50a4548.svg";
export { ForwardRef as ReactComponent };